// Consider whether or not this rendering flow that's split between home and default navs makes any sense..

import React from 'react';
import './Nav.css';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import { useThemeMode } from '../../utils/useThemeMode';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import logoHorizontalIcon from 'icons/logo-horizontal.svg';

const Nav = ({ className = '', children, ...props }) => {
  const location = useLocation();
  const { mode } = useThemeMode();
  const theme = useTheme();

  const renderHomeNav = () => (
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav ml-auto w-100 justify-content-end">
        <li className="nav-item">
          <ScrollLink to="top" smooth={true} className="nav-link active">
            Home
          </ScrollLink>
        </li>
        <li className="nav-item">
          <ScrollLink to="about" smooth={true} className="nav-link">
            About
          </ScrollLink>
        </li>
        <li className="nav-item">
          <ScrollLink to="foreal" smooth={true} className="nav-link">
            Learn More
          </ScrollLink>
        </li>
        <li className="nav-item">
          <Link to="/signup" className="nav-link">
            Join Now
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/login" className="nav-link">
            Login
          </Link>
        </li>
      </ul>
    </div>
  );

  const renderDefaultNav = () => (
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav ml-auto w-100 justify-content-end">
        <li className="nav-item">
          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            end
          >
            Home
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/signup"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            Sign Up
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/login"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            Login
          </NavLink>
        </li>
      </ul>
    </div>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar 
        position="static" 
        color="transparent" 
        sx={{ 
          backgroundColor: theme.palette.background.paper,
          boxShadow: 1
        }}
      >
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Link to="/" className="navbar-brand">
              <img 
                src={logoHorizontalIcon} 
                width="250" 
                alt="Career Deer" 
                className={mode === 'dark' ? 'logo-dark' : 'logo-light'} 
              />
            </Link>
          </Typography>
          <Link to="/login">
            <Button 
              color="primary" 
              variant="contained"
              sx={{ marginRight: 2 }}
            >
              Login
            </Button>
          </Link>
          <Link to="/signup">
            <Button 
              color="secondary" 
              variant="contained"
            >
              Sign Up
            </Button>
          </Link>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export { Nav };
